var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.isEditing ? "Kuralı Düzenle" : "Yeni Kural Oluştur",
        width: "900px",
        footer: null,
        bodyStyle: { padding: "24px" },
      },
      on: { cancel: _vm.onCancel },
    },
    [
      _c(
        "div",
        { staticClass: "rule-editor" },
        [
          _c(
            "a-steps",
            {
              staticClass: "steps-container",
              attrs: { current: _vm.currentStep, size: "small" },
              on: { change: _vm.onStepChange },
            },
            [
              _c("a-step", { attrs: { title: "Ne Zaman?" } }),
              _vm._v(" "),
              _c("a-step", { attrs: { title: "Koşullar" } }),
              _vm._v(" "),
              _c("a-step", { attrs: { title: "Aksiyonlar" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-content" }, [
            _vm.currentStep === 0
              ? _c("div", { staticClass: "when-step" }, [
                  _c("h3", [_vm._v("Kural Ne Zaman Çalışsın?")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rule-name-input" },
                    [
                      _c("label", [_vm._v("Kural Adı")]),
                      _vm._v(" "),
                      _c("a-input", {
                        attrs: {
                          placeholder: "Kural için bir isim girin",
                          size: "large",
                        },
                        model: {
                          value: _vm.localRule.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.localRule, "name", $$v)
                          },
                          expression: "localRule.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "when-options" },
                    _vm._l(_vm.whenOptions, function (option) {
                      return _c(
                        "div",
                        {
                          key: option.value,
                          staticClass: "when-option",
                          class: {
                            selected: _vm.localRule.when === option.value,
                          },
                          on: {
                            click: function ($event) {
                              _vm.localRule.when = option.value
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "option-icon" }, [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(_vm._s(option.icon)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "option-content" }, [
                            _c("h4", [_vm._v(_vm._s(option.label))]),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(option.description))]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "option-check" }, [
                            _vm.localRule.when === option.value
                              ? _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("check_circle"),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 1
              ? _c(
                  "div",
                  { staticClass: "if-step" },
                  [
                    _c("h3", [_vm._v("Hangi Koşullar Sağlanmalı?")]),
                    _vm._v(" "),
                    _c("FilterBuilder", {
                      attrs: {
                        "when-type": _vm.localRule.when,
                        "workflow-id": _vm.workflowId,
                      },
                      model: {
                        value: _vm.localRule.conditions,
                        callback: function ($$v) {
                          _vm.$set(_vm.localRule, "conditions", $$v)
                        },
                        expression: "localRule.conditions",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 2
              ? _c(
                  "div",
                  { staticClass: "actions-step" },
                  [
                    _c("h3", [_vm._v("Hangi Aksiyonlar Çalışsın?")]),
                    _vm._v(" "),
                    _c("ActionsEditor", {
                      attrs: {
                        "when-type": _vm.localRule.when,
                        "workflow-id": _vm.workflowId,
                      },
                      model: {
                        value: _vm.localRule.actions,
                        callback: function ($$v) {
                          _vm.$set(_vm.localRule, "actions", $$v)
                        },
                        expression: "localRule.actions",
                      },
                    }),
                    _vm._v(" "),
                    _vm.localRule
                      ? _c("div", { staticClass: "advanced-settings" }, [
                          _c("h3", [_vm._v("Gelişmiş Ayarlar")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "setting-item" }, [
                            _c(
                              "div",
                              { staticClass: "setting-header" },
                              [
                                _c("a-switch", {
                                  on: { change: _vm.onTriggerOtherRulesChange },
                                  model: {
                                    value: _vm.localRule.triggerOtherRules,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localRule,
                                        "triggerOtherRules",
                                        $$v
                                      )
                                    },
                                    expression: "localRule.triggerOtherRules",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "setting-info" }, [
                                  _c("h4", [_vm._v("Diğer Kuralları Tetikle")]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    [
                                      _vm._v(
                                        "\n                                    Bu kuralın aksiyonları görevi güncellediğinde, diğer kurallar da çalışsın mı? \n                                    "
                                      ),
                                      _c(
                                        "a-tooltip",
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              '\n                                            Örneğin bu kural stage değiştirirse, "stage değiştiğinde" tetiklenen diğer kurallar da çalışır. \n                                            Döngü önlemi için maksimum 10 zincirleme kural çalışabilir.\n                                        '
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons info-icon",
                                            },
                                            [_vm._v("info")]
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "setting-item" }, [
                            _c(
                              "div",
                              { staticClass: "setting-header" },
                              [
                                _c("a-switch", {
                                  on: {
                                    change: _vm.onReportToAutomationChange,
                                  },
                                  model: {
                                    value: _vm.localRule.reportToAutomation,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localRule,
                                        "reportToAutomation",
                                        $$v
                                      )
                                    },
                                    expression: "localRule.reportToAutomation",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "setting-info" }, [
                                  _c("h4", [
                                    _vm._v("Supsis Otomasyonlarına Bildir"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    [
                                      _vm._v(
                                        "\n                                    Bu kuralın aksiyonları Supsis Otomasyon sistemine bildirilsin mi? \n                                    "
                                      ),
                                      _c(
                                        "a-tooltip",
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(
                                              "\n                                            Aktif edilirse, bu kuralın yaptığı değişiklikler (assignee değişimi, stage değişimi vb.) \n                                            Supsis Otomasyon sistemindeki ilgili otomasyonları tetikler.\n                                        "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "material-icons info-icon",
                                            },
                                            [_vm._v("info")]
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step-navigation" },
            [
              _vm.currentStep > 0
                ? _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.currentStep--
                        },
                      },
                    },
                    [_vm._v("\n                Geri\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "spacer" }),
              _vm._v(" "),
              _c("a-button", { on: { click: _vm.onCancel } }, [
                _vm._v("\n                İptal\n            "),
              ]),
              _vm._v(" "),
              _vm.currentStep < 2
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.canProceed },
                      on: {
                        click: function ($event) {
                          _vm.currentStep++
                        },
                      },
                    },
                    [_vm._v("\n                İleri\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 2
                ? _c(
                    "a-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                    [_vm._v("\n                Kaydet\n            ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }